import { defineMessages } from 'react-intl'

export default defineMessages({
  connectorNameTooltip: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.Connector.NameTooltip',
    defaultMessage: 'This name will be displayed on as the source on an app'
  },
  requiredError: {
    id: 'FormError.Required',
    defaultMessage: 'Please enter a value.'
  },
  connectorName: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.Connector.Name',
    defaultMessage: 'Source Name'
  },
  connectorIconUrl: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.Connector.IconURL',
    defaultMessage: 'Source Icon URL & Preview'
  },
  connectorNamePlaceholder: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.Connector.Name.Placeholder',
    defaultMessage: 'Source Name'
  },
  connectorIconUrlPlaceholder: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.Connector.IconURL.Placeholder',
    defaultMessage: 'https://www.exampleurl.com/sourceLogo.png'
  },
  disableCheck: {
    id: 'SpaceAppsPage.AppCatalog.Installation.DisableCheck',
    defaultMessage: 'Do you really want to disable?'
  },
  disableConfirm: {
    id: 'SpaceAppsPage.AppCatalog.Installation.DisableConfirm',
    defaultMessage: 'Yes, disable'
  },
  disablingSmartNotifications: {
    id: 'SpaceAppsPage.AppCatalog.Installation.DisablingSmartNotifications',
    defaultMessage: 'Disabling this will delete all past or pending notifications for users.'
  },
  webHookUrl: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.Connector.WebHookUrl',
    defaultMessage: 'Web Hook URL'
  },
  webHookUrlPlaceHolder: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.Connector.WebHookUrl.Placeholder',
    defaultMessage: 'https://www.exampleurl.com/webhook'
  },
  webHookUrlTooltip: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.Connector.WebHookURLToolTip',
    defaultMessage: 'URL to receive web hook events from smart notifications created by this connector'
  },
  smartNotifications: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.Connector.SmartNotifications',
    defaultMessage: 'Smart Notifications'
  },
  smartNotificationsDescription: {
    id: 'AppInstanceForm.SmartNotificationsDescription',
    defaultMessage:
      'Smart Notifications are personalized and contextual communications. Examples include: approvals, alerts, and task-oriented notifications.'
  },
  subcomponentDescriptionOff: {
    id: 'AppInstanceForm.DescriptionOff',
    defaultMessage: 'This feature is currently OFF.'
  },
  clientId: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.Connector.ClientId',
    defaultMessage: 'Client Id'
  },
  clientSecret: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.Connector.ClientSecret',
    defaultMessage: 'Client Secret'
  },
  onlyDisplayedOnce: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.Connector.OnlyDisplayedOnce',
    defaultMessage: '(this is only displayed once!)'
  },
  settingsFunctionality: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.SettingsFunctionality',
    defaultMessage: 'Settings, Functionality & Features'
  },
  defaultNameAndUrl: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.Connector.defaultNameAndUrl',
    defaultMessage: 'Same as App Name & Icon URL'
  },
  sourceNameAndIcon: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.Connector.sourceNameAndIcon',
    defaultMessage: 'Notification Source Name & Icon URL'
  },
  logs: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.Logs',
    defaultMessage: 'View Logs'
  }
})
